// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

const patientDashboard = (state) => get(state, ['patient', 'dashboard'], {})

export const patientBillingStatistics$ = createSelector(
  patientDashboard,
  ({ patientBillingStatistics }) => patientBillingStatistics
)
